export default __webpack_public_path__ + "static/media/diuQuiz-logo.ca36a01f.webp";